import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AppsSharedModule,
  BaseAdministrationModule,
  BaseDocumentsModule,
  BaseRelatedPspBranchesModule,
  BaseSharedModule,
} from 'base';
import { BaseCustomerProviderDetailsMasterDataComponent } from './_components/provider-details-master-data/base-customer-provider-details-master-data.component';
import { BaseCustomerProviderDetailsEmployeeLeaseComponent } from './_components/provider-details-employee-lease/base-customer-provider-details-employee-lease.component';
import { BaseCustomerProviderListComponent } from './_components/provider-list/base-customer-provider-list.component';
import { BaseCustomerProviderListItemComponent } from './_components/provider-list-item/base-customer-provider-list-item.component';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseCustomerProviderListFiltersComponent } from './_components/provider-list-filters/base-customer-provider-list-filters.component';
import { BaseCustomerProviderIzsInfoComponent } from './_components/provider-izs-info/provider-izs-info.component';
import { ProviderDetailsModalComponent } from './_components/provider-details-modal/provider-details-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BaseSharedModule,
    AppsSharedModule,
    BaseRelatedPspBranchesModule,
    BaseDocumentsModule,
    BaseCustomerSharedModule,
    RouterModule,
    NgbTooltipModule,
    BaseAdministrationModule,
  ],
  declarations: [
    BaseCustomerProviderDetailsEmployeeLeaseComponent,
    BaseCustomerProviderDetailsMasterDataComponent,
    BaseCustomerProviderListComponent,
    BaseCustomerProviderListItemComponent,
    BaseCustomerProviderListFiltersComponent,
    BaseCustomerProviderIzsInfoComponent,
    ProviderDetailsModalComponent,
  ],
  exports: [
    BaseCustomerProviderDetailsEmployeeLeaseComponent,
    BaseCustomerProviderDetailsMasterDataComponent,
    BaseCustomerProviderListComponent,
    BaseCustomerProviderListItemComponent,
    BaseCustomerProviderListFiltersComponent,
    BaseCustomerProviderIzsInfoComponent,
    ProviderDetailsModalComponent,
  ],
})
export class BaseCustomerProviderModule {}
